module.exports = __webpack_public_path__ + "static/media/Polygon.304d0944.svg";